import React from 'react';
import { Pie } from 'react-chartjs-2';
import { FiltroSopSales, RepositorioSopSales } from '../../core/repositories/sopSalesRepositorio';
import { ChartData } from 'chart.js';
import { colorGraph, formatLargeNumber } from '../../core/utils/funcoes';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';

const SopSalesRegionPieChart: React.FC<{ filtro: FiltroSopSales }> = (props) => {

    const { mostrarToast } = useToast();
    const { t } = useTranslation();
    const [data, setData] = React.useState<ChartData<"pie">>({} as ChartData<"pie">);
    const [carregando, setCarregando] = React.useState(true);

    React.useEffect(() => {
        setCarregando(true);
        new RepositorioSopSales().getShareRegion(props.filtro).then((res) => {
            setData({
                labels: res.map((x: any) => x.des_region),
                datasets: [
                    {
                        label: 'Revenue Share',
                        data: res.map((x: any) => x.pct),
                        backgroundColor: colorGraph(),
                        borderColor: '#fff',
                        borderWidth: 2,
                    }
                ]
            });
            setCarregando(false);
        }).catch((error) => {
            mostrarToast({
                titulo: t("pages.Erro!"),
                mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                tipo: "error",
            });
        })
    }, [props.filtro]);


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right' as const,
                labels: {
                    color: '#333',
                    font: {
                        size: 14,
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context: any) {
                        const value = context.parsed;
                        return `${context.label}: ${value}%`;
                    },
                },
            },
        },
     
    };

    return (
        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className=" title-card">{props.filtro?.value !== "Quantity" ? 'Revenue' : 'Quantity'} Share by Region</strong>
            {carregando ?
                <SopLoadingAnimation type="PIE" />
                :
                    <Pie data={data} options={options} />
            }
        </div>

    );
};

export default SopSalesRegionPieChart;
